import { render } from "./Create.vue?vue&type=template&id=1181decd&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Create.vue?vue&type=style&index=1&id=1181decd&scoped=true&lang=css"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1181decd"],['__file',"resources/js/Pages/Task/Create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1181decd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1181decd', __exports__)) {
    console.log('reload')
    api.reload('1181decd', __exports__)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=1181decd&scoped=true", () => {
    console.log('re-render')
    api.rerender('1181decd', render)
  })

}


export default __exports__